import { render } from "./FavouritesEditForm.vue?vue&type=template&id=02473ccb&scoped=true"
import script from "./FavouritesEditForm.vue?vue&type=script&lang=js"
export * from "./FavouritesEditForm.vue?vue&type=script&lang=js"

import "./FavouritesEditForm.vue?vue&type=style&index=0&id=02473ccb&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02473ccb"]])

export default __exports__